import React, { useMemo, createContext, useReducer } from 'react';

const initialState = {
    isOpen: false,
    headline: null,
    headlineIcon: null,
    headlineIconColor: null,
    boxType: 'inform',
    content: '',
    buttonText: 'OK',
    confirmButtonText: 'Confirm',
    cancelButtonText: 'Cancel',
    buttonIcon: null,
    confirmButtonIcon: null,
    cancelButtonIcon: null,
    secondaryButtonText: null,
    secondaryButtonIcon: null,
    secondaryCloseCallback: null,
    actionCallback: null,
    closeCallback: null
};

const actions = {
    SET_STATUS: 'SET_STATUS',
    INITIALIZE: 'INITIALIZE'
};

function reducer(state, action) {
    switch (action.type) {
        case actions.SET_STATUS:
            return { ...state, isOpen: action.isOpen };
        case actions.INITIALIZE:
            return {
                ...state,
                isOpen: true,
                headline: action.headline || null,
                headlineIcon: action.headlineIcon || null,
                headlineIconColor: action.headlineIconColor || null,
                boxType: action.boxType || state.boxType,
                content: action.content || state.content,
                buttonText: action.buttonText || 'Ok',
                confirmButtonText: action.confirmButtonText || state.confirmButtonText,
                cancelButtonText: action.cancelButtonText || state.cancelButtonText,
                buttonIcon: action.buttonIcon || state.buttonIcon,
                confirmButtonIcon: action.confirmButtonIcon || state.confirmButtonIcon,
                cancelButtonIcon: action.cancelButtonIcon || state.cancelButtonIcon,
                actionCallback: action.actionCallback || state.actionCallback,
                closeCallback: action.closeCallback || null,
                secondaryButtonText: action.secondaryButtonText || null,
                secondaryButtonIcon: action.secondaryButtonIcon || null,
                secondaryCloseCallback: action.secondaryCloseCallback || null,
            }
        default:
            return state;
    }
}

export const CustomAlertContext = createContext();

const CustomAlertContextProvider = ({ children }) => {
    const [state, dispatch] = useReducer(reducer, initialState);

    const value = useMemo(() => ({
        isOpen: state.isOpen,
        headline: state.headline,
        headlineIcon: state.headlineIcon,
        headlineIconColor: state.headlineIconColor,
        boxType: state.boxType,
        content: state.content,
        buttonText: state.buttonText,
        confirmButtonText: state.confirmButtonText,
        cancelButtonText: state.cancelButtonText,
        buttonIcon: state.buttonIcon,
        confirmButtonIcon: state.confirmButtonIcon,
        cancelButtonIcon: state.cancelButtonIcon,
        actionCallback: state.actionCallback,
        closeCallback: state.closeCallback,
        secondaryButtonText: state.secondaryButtonText,
        secondaryButtonIcon: state.secondaryButtonIcon,
        secondaryCloseCallback: state.secondaryCloseCallback,
        setStatus: status => dispatch({ type: actions.SET_STATUS, isOpen: status }),
        initialize: (initialObject) => {
            dispatch({ type: actions.INITIALIZE, ...initialObject })
        },
    }), [state, dispatch]);

    return (
        <CustomAlertContext.Provider value={value}>
            {children}
        </CustomAlertContext.Provider>
    );
}

export default CustomAlertContextProvider;
